import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/tema3/planeProductSub3Act3.glb"
import { GUI } from "dat.gui";

export class PlaneProductExpired extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(0.4484, 0.4484, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			this.salchicasExpiradas = gltf.scene.getObjectByName("salchicasExpiradas", true);
			this.empaque = gltf.scene.getObjectByName("empaque", true);
			this.Pan1 = gltf.scene.getObjectByName("Pan1", true);
			this.tomate = gltf.scene.getObjectByName("tomate", true);
			this.salchichasCaducadas = gltf.scene.getObjectByName("salchichasCaducadas", true);
		});
	}

	onInVisible() {
		this.salchicasExpiradas.visible = false
		this.empaque.visible = false
		this.Pan1.visible = false
		this.tomate.visible = false
		this.salchichasCaducadas.visible = false
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("PlanosCaducados");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		premiaFolder.add(this.scale, "x", -5, 5).step(0.0001).name("scale X");
		premiaFolder.add(this.scale, "y", -5, 5).step(0.0001).name("scale Y");
		premiaFolder.add(this.scale, "z", -5, 5).step(0.0001).name("scale Z");
		premiaFolder.add(this, "visible").name("Visible");
	}


	renderAnimations() { }
}
